var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tasks-template',{ref:"tasks",attrs:{"tool":"inspector"}}),_c('floating-repair-select',{on:{"open":_vm.openChatBox}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }